export const byID = (state, payload, found_cb, nf_cb) => {
    let index = state.items.findIndex((o)=>o.ID === payload.ID);
    if (index >= 0) {
        found_cb && found_cb(index);
    } else {
        nf_cb && nf_cb();    
    }
}

export const bySymbol = (state, payload, found_cb, nf_cb) => {
  let index = state.items.findIndex((o)=>o.Symbol === payload.Symbol);
  if (index >= 0) {
    found_cb && found_cb(index);
  } else {
    nf_cb && nf_cb();
  }
}